export const getOperatorListMock = {
	operatorList: [
		{
			fpId: '0',
			name: 'Demosite',
			parentOperator: '0',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '1',
			name: 'Sylph',
			parentOperator: '1',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '2',
			name: 'GamingWorld',
			parentOperator: '2',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '3',
			name: 'DrGaming',
			parentOperator: '3',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '5',
			name: 'SBOBET',
			parentOperator: '5',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '6',
			name: 'Digient',
			parentOperator: '6',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '7',
			name: 'BetAdvance',
			parentOperator: '7',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '8',
			name: 'Superswan',
			parentOperator: '8',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '9',
			name: '568Win',
			parentOperator: '9',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '11',
			name: 'IBC',
			parentOperator: '11',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '12',
			name: 'SylphT',
			parentOperator: '12',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '13',
			name: 'DragonSoft',
			parentOperator: '13',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '14',
			name: 'SylphIBC',
			parentOperator: '14',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '15',
			name: 'ABLIVECASINO',
			parentOperator: '15',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '16',
			name: 'Vin88',
			parentOperator: '16',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '17',
			name: 'Xitment',
			parentOperator: '17',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '18',
			name: 'EasyGaming',
			parentOperator: '18',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '19',
			name: 'EasyGame88',
			parentOperator: '19',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '21',
			name: 'WM-W21test',
			parentOperator: '21',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '22',
			name: 'AUQI-hbo',
			parentOperator: '22',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '23',
			name: 'Ambsuperslot',
			parentOperator: '23',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '24',
			name: 'PGS',
			parentOperator: '24',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '25',
			name: 'Fortuno',
			parentOperator: '25',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '26',
			name: 'MGP',
			parentOperator: '26',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '27',
			name: 'Hwin168-DSTBET',
			parentOperator: '27',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '28',
			name: 'Hwin168',
			parentOperator: '28',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '30',
			name: 'xtu168',
			parentOperator: '30',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '31',
			name: 'Great Ent Co',
			parentOperator: '31',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '32',
			name: 'EXP',
			parentOperator: '32',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '33',
			name: 'GamingSoft-T',
			parentOperator: '33',
			isMasterOperator: true,
			isReseller: true,
			isTransfer: true,
		},
		{
			fpId: '34',
			name: 'GamingSoft-S',
			parentOperator: '34',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '35',
			name: 'HWFNKWENFA',
			parentOperator: '35',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '36',
			name: 'GPlay',
			parentOperator: '36',
			isMasterOperator: true,
			isReseller: true,
			isTransfer: false,
		},
		{
			fpId: '37',
			name: 'ThirtyThree',
			parentOperator: '37',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '38',
			name: 'Immortal',
			parentOperator: '38',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '39',
			name: 'istar',
			parentOperator: '39',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '41',
			name: 'Mrslotty-ire',
			parentOperator: '41',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '42',
			name: 'Spadeclub',
			parentOperator: '42',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '43',
			name: 'ism',
			parentOperator: '43',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '44',
			name: 'Big Data Centre SDN',
			parentOperator: '44',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '45',
			name: 'tg',
			parentOperator: '45',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '46',
			name: 'Egadmin',
			parentOperator: '46',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '47',
			name: 'Razer',
			parentOperator: '47',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '48',
			name: 'Markor',
			parentOperator: '48',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '49',
			name: 'HWFNKWF',
			parentOperator: '49',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '50',
			name: 'X2',
			parentOperator: '50',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '51',
			name: 'Ironman',
			parentOperator: '51',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '52',
			name: 'Winbet',
			parentOperator: '52',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '53',
			name: 'XiaoXiang',
			parentOperator: '53',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '54',
			name: 'JXIT',
			parentOperator: '54',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '55',
			name: 'USSBET',
			parentOperator: '55',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '56',
			name: 'Neftsoft',
			parentOperator: '56',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '57',
			name: 'Hwin168-rapa',
			parentOperator: '57',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '58',
			name: 'Hwin168-HWUP8FK',
			parentOperator: '58',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '59',
			name: 'Leekie',
			parentOperator: '59',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '60',
			name: 'Betksh',
			parentOperator: '60',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '61',
			name: 'WS',
			parentOperator: '61',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '62',
			name: 'Hwin168-Gbet',
			parentOperator: '62',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '63',
			name: 'GST',
			parentOperator: '63',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '64',
			name: 'HWTGBTFNK',
			parentOperator: '64',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '65',
			name: 'Okbet',
			parentOperator: '65',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '99',
			name: 'maple',
			parentOperator: '99',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '111',
			name: 'SylphReseller',
			parentOperator: '',
			isMasterOperator: false,
			isReseller: true,
			isTransfer: true,
		},
		{
			fpId: '128',
			name: 'Hwin168-all',
			parentOperator: '',
			isMasterOperator: false,
			isReseller: true,
			isTransfer: true,
		},
		{
			fpId: '168',
			name: 'JClub777',
			parentOperator: '168',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '1680',
			name: 'demogame',
			parentOperator: '1680',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '9999',
			name: 'kevin',
			parentOperator: '9999',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '10004',
			name: 'zoe',
			parentOperator: '1',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '10008',
			name: 'GARYSUBLINE01',
			parentOperator: '1',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '10009',
			name: 'GARYSUBLINE03',
			parentOperator: '1',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '10010',
			name: 'GARYTESTSUBLINE03',
			parentOperator: '1',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '30001',
			name: 'DrGaming-DG001',
			parentOperator: '3',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '30002',
			name: 'DrGaming-DG002',
			parentOperator: '3',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '30003',
			name: 'DrGaming-DG003',
			parentOperator: '3',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '30005',
			name: 'DrGaming-DG005',
			parentOperator: '3',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '30006',
			name: 'DrGaming-DG006',
			parentOperator: '3',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '30007',
			name: 'DrGaming-DG007',
			parentOperator: '3',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '80001',
			name: 'Superswan-SS001',
			parentOperator: '8',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '80005',
			name: 'Superswan-SS005',
			parentOperator: '8',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '80006',
			name: 'Superswan-SS006',
			parentOperator: '8',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '80007',
			name: 'Superswan-SS007',
			parentOperator: '8',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '80009',
			name: 'Superswan-SS009',
			parentOperator: '8',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '90001',
			name: '568winCT',
			parentOperator: '9',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '130001',
			name: 'GARYSUBLINE02',
			parentOperator: '13',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '150001',
			name: 'ABLIVECASINO-wbfapi',
			parentOperator: '15',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '150002',
			name: 'ABLIVECASINO-lgf',
			parentOperator: '15',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '150003',
			name: 'ABLIVECASINO-vhf',
			parentOperator: '15',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '150004',
			name: 'ABLIVECASINO-j19',
			parentOperator: '15',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '150006',
			name: 'ABLIVECASINO-yaf',
			parentOperator: '15',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '150007',
			name: 'ABLIVECASINO-hbf',
			parentOperator: '15',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '150008',
			name: 'ABLIVECASINO-lkf',
			parentOperator: '15',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '150009',
			name: 'ABLIVECASINO-j31HKD',
			parentOperator: '15',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '150010',
			name: 'ABLIVECASINO-j31KVND',
			parentOperator: '15',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '180001',
			name: 'EasyGaming-KK001',
			parentOperator: '18',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '180002',
			name: 'EasyGaming-85bet',
			parentOperator: '18',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '180003',
			name: 'EasyGaming-VW',
			parentOperator: '18',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '180004',
			name: 'EasyGaming-BKK',
			parentOperator: '18',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '180005',
			name: 'EasyGaming-SKA888',
			parentOperator: '18',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '180006',
			name: 'EasyGaming-V79',
			parentOperator: '18',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '180007',
			name: 'EasyGaming-Play599',
			parentOperator: '18',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '190001',
			name: 'EasyGame88-VND',
			parentOperator: '19',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '190002',
			name: 'EasyGame88-THB',
			parentOperator: '19',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '190003',
			name: 'EasyGame88-IDR',
			parentOperator: '19',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '190004',
			name: 'EasyGame88-MYR',
			parentOperator: '19',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '210001',
			name: 'WM-VBF',
			parentOperator: '21',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '210002',
			name: 'WM-GOF',
			parentOperator: '21',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '210003',
			name: 'WM-AAF',
			parentOperator: '21',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '210004',
			name: 'WM-WCF',
			parentOperator: '21',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '210005',
			name: 'WM-INF',
			parentOperator: '21',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '210006',
			name: 'WM-BOF',
			parentOperator: '21',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '210007',
			name: 'WM-JQF',
			parentOperator: '21',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '210008',
			name: 'WM-CWF',
			parentOperator: '21',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '210009',
			name: 'WM-WWF',
			parentOperator: '21',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '210010',
			name: 'WM-JZF',
			parentOperator: '21',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '230001',
			name: 'Amb-Supergame99',
			parentOperator: '23',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '260001',
			name: 'MGP-RSG',
			parentOperator: '26',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '270001',
			name: 'Dstbet-bet1776',
			parentOperator: '27',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '270002',
			name: 'Dstbet-hoh966',
			parentOperator: '27',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '270003',
			name: 'Dstbet-ubet3399',
			parentOperator: '27',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '270004',
			name: 'Dstbet-wynnbet',
			parentOperator: '27',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '270005',
			name: 'Dstbet-ozbetau',
			parentOperator: '27',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '270006',
			name: 'Dstbet-jutaclub',
			parentOperator: '27',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '270007',
			name: 'Dstbet-luckybet333',
			parentOperator: '27',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '270008',
			name: 'Dstbet-wcgbet',
			parentOperator: '27',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '270009',
			name: 'Dstbet-play22bet',
			parentOperator: '27',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '270010',
			name: 'Dstbet-win777',
			parentOperator: '27',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '270011',
			name: 'Dstbet-winners33',
			parentOperator: '27',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '270012',
			name: 'GaryHwinDSTBET',
			parentOperator: '27',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '270013',
			name: 'GaryTest02',
			parentOperator: '27',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '280001',
			name: 'Hwin168-Bagus545',
			parentOperator: '28',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '280002',
			name: 'Hwin168-Menang44',
			parentOperator: '28',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '280003',
			name: 'Hwin168-jom8888',
			parentOperator: '28',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '280004',
			name: 'Hwin168-bossku96',
			parentOperator: '28',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '280005',
			name: 'Hwin168-starplay888',
			parentOperator: '28',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '280006',
			name: 'Hwin168-9club33',
			parentOperator: '28',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '280007',
			name: 'Hwin168-7liveasean88',
			parentOperator: '28',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '280008',
			name: 'Hwin168-googleplay',
			parentOperator: '28',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '280009',
			name: 'Hwin168-3aw8',
			parentOperator: '28',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '280010',
			name: 'Hwin168-918kisscompany',
			parentOperator: '28',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '300001',
			name: 'xtu168-yibo-MYR',
			parentOperator: '30',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '300002',
			name: 'xtu168-MYR',
			parentOperator: '30',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '300003',
			name: 'xtu168-IDR',
			parentOperator: '30',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '300004',
			name: 'xtu168-VND',
			parentOperator: '30',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '300005',
			name: 'xtu168-CNY',
			parentOperator: '30',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '320001',
			name: 'EXP-ambsuperapi',
			parentOperator: '32',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '320002',
			name: 'EXP-ambnewsportbook',
			parentOperator: '32',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '330001',
			name: 'GamingSoft-T-whitejoker88',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330002',
			name: 'GamingSoft-T-whitejokercn',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330003',
			name: 'GamingSoft-T-fab789',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330004',
			name: 'GamingSoft-T-whitejokerin',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330005',
			name: 'GamingSoft-T-ttbet18my',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330006',
			name: 'GamingSoft-T-wynnbet365sg',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330007',
			name: 'GamingSoft-T-BETASIAMY',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330008',
			name: 'GamingSoft-T-CASINOJRMY',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330009',
			name: 'GamingSoft-T-DELUXEWINMY',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330010',
			name: 'GamingSoft-T-TLGBETHK',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330201',
			name: 'GamingSoft-T-MMK22-jdhbetid',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330301',
			name: 'GamingSoft-T-Daniel Tan-VVIP68',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330302',
			name: 'GamingSoft-T-DT-BINGOCITY88PHP',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330401',
			name: 'GamingSoft-T-WTB-IG918',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330402',
			name: 'GamingSoft-T-WTB-IKFC4U',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330403',
			name: 'GamingSoft-T-WTB-JOMWIN8',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330404',
			name: 'GamingSoft-T-WTB-EGOFFICE4U',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330405',
			name: 'GamingSoft-T-WTB-DKING88',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330406',
			name: 'GamingSoft-T-WTB-TRUST88',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330407',
			name: 'GamingSoft-T-WTB-1SLOT',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330408',
			name: 'GamingSoft-T-WTB-JUDIASIA96',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330409',
			name: 'GamingSoft-T-WTB-WINSCLUB888',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330410',
			name: 'GamingSoft-T-WTB-JW88MY',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330501',
			name: 'GamingSoft-T-CSL-CSLTHB',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330502',
			name: 'GamingSoft-T-CSL-CSLVND',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330601',
			name: 'GamingSoft-T-ABT-BURBERRY777MY',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330602',
			name: 'GamingSoft-T-ABT-EZY18DEMOMYR',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330603',
			name: 'GamingSoft-T-ABT-EZY18DEMOUSD',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330604',
			name: 'GamingSoft-T-ABT-M1PLAYMYR',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330701',
			name: 'GamingSoft-T-DM-BIGBETWOLFAUD',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330801',
			name: 'GamingSoft-T-GM-BET123ID',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330802',
			name: 'GamingSoft-T-GM-BET123TH',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330803',
			name: 'GamingSoft-T-GM-BET123VN',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330901',
			name: 'GamingSoft-T-1XPOWER-1XGCSMYR',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330902',
			name: 'GamingSoft-T-1XPOWER-EZY18MYR',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330903',
			name: 'GamingSoft-T-1XPOWER-EZY18USD',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '330904',
			name: 'GamingSoft-T-1XPOWER-WLT54MY',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331000',
			name: 'GamingSoft-T-BB77',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331001',
			name: 'GamingSoft-T-BB77-IMONEY66MY',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331002',
			name: 'GamingSoft-T-BB77-MY043MYR',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331100',
			name: 'GamingSoft-T-Besttag',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331101',
			name: 'GamingSoft-T-Besttag-JCLUB99MYR',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331102',
			name: 'GamingSoft-T-Besttag-AWCLUB8MYR',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331103',
			name: 'GamingSoft-T-Besttag-KCLUB8MYR',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331104',
			name: 'GamingSoft-T-Besttag-PPCLUB99MYR',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331105',
			name: 'GamingSoft-T-Besttag-JSTAR888MYR',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331106',
			name: 'GamingSoft-T-Besttag-JCLUB55THB',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331200',
			name: 'GamingSoft-T-ALIBABA',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331201',
			name: 'GamingSoft-T-ALIBABA-KING66IDR',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331202',
			name: 'GamingSoft-T-ALIBABA-TAXI666MYR',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331203',
			name: 'GamingSoft-T-ALIBABA-SLOT66BND',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331204',
			name: 'GamingSoft-T-ALIBA-ALIBABA66THB',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331300',
			name: 'GamingSoft-T-CL1356',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '331301',
			name: 'GamingSoft-T-CL1356-PLAY69WINHKD',
			parentOperator: '33',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '350001',
			name: 'HWFNKWENFA-easywin459',
			parentOperator: '35',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '350003',
			name: 'HWFNKWENFA-judiwin66',
			parentOperator: '35',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '350004',
			name: 'HWFNKWENFA-8kingclub',
			parentOperator: '35',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '350005',
			name: 'HWFNKWENFA-my918',
			parentOperator: '35',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '350006',
			name: 'HWFNKWENFA-sdmbet777',
			parentOperator: '35',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '350007',
			name: 'HWFNKWENFA-we88city',
			parentOperator: '35',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '350008',
			name: 'HWFNKWENFA-Rjbet77',
			parentOperator: '35',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '350009',
			name: 'HWFNKWENFA-Rojak888',
			parentOperator: '35',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '350010',
			name: 'HWFNKWENFA-Kissy918',
			parentOperator: '35',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '360001',
			name: 'GPlay-PSG2020',
			parentOperator: '360001',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360002',
			name: 'GPlay-Asia999',
			parentOperator: '360002',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360003',
			name: 'GPlay-Supper777',
			parentOperator: '360003',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360004',
			name: 'GPlay-TARIK',
			parentOperator: '360004',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '360005',
			name: 'GPlay-betaday888',
			parentOperator: '360005',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '360006',
			name: 'Gplay-Msnslot',
			parentOperator: '360006',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360100',
			name: 'GPlay-12P66G',
			parentOperator: '360100',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360101',
			name: 'GPlay-12P66G-Panama888',
			parentOperator: '36',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360102',
			name: 'GPlay-12P66G-vip168sa',
			parentOperator: '36',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360103',
			name: 'GPlay-12P66G-sagame6699',
			parentOperator: '36',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360104',
			name: 'GPlay-12P66G-ssgame666',
			parentOperator: '36',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360105',
			name: 'GPlay-12P66G-sexygame666',
			parentOperator: '36',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360106',
			name: 'GPlay-12P66G-sagame350',
			parentOperator: '36',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360107',
			name: 'GPlay-12P66G-ssgame350',
			parentOperator: '36',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360108',
			name: 'GPlay-12P66G-juad888',
			parentOperator: '36',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360109',
			name: 'GPlay-12P66G-hydra888',
			parentOperator: '36',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360110',
			name: 'GPlay-12P66G-kingdom66',
			parentOperator: '36',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360200',
			name: 'GPlay-GP119',
			parentOperator: '360200',
			isMasterOperator: true,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '360201',
			name: 'GPlay-GP119-GPAG1',
			parentOperator: '36',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '370001',
			name: 'ThirtyThree-TT001',
			parentOperator: '37',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '370002',
			name: 'ThirtyThree-TT002',
			parentOperator: '37',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '370003',
			name: 'ThirtyThree-TT003',
			parentOperator: '37',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '370004',
			name: 'ThirtyThree-TT004',
			parentOperator: '37',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '370005',
			name: 'ThirtyThree-TT005',
			parentOperator: '37',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '370006',
			name: 'ThirtyThree-TT006',
			parentOperator: '37',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '370007',
			name: 'ThirtyThree-TT007',
			parentOperator: '37',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '370008',
			name: 'ThirtyThree-TT008',
			parentOperator: '37',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '370009',
			name: 'ThirtyThree-TT009',
			parentOperator: '37',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '370010',
			name: 'ThirtyThree-TT010',
			parentOperator: '37',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '380001',
			name: 'Immortal-A96',
			parentOperator: '38',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '380002',
			name: 'Immortal-BLW',
			parentOperator: '38',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '380003',
			name: 'Immortal-LVK',
			parentOperator: '38',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '380004',
			name: 'Immortal-SSE',
			parentOperator: '38',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '380005',
			name: 'Immortal-VBG',
			parentOperator: '38',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '380006',
			name: 'Immortal-CLB',
			parentOperator: '38',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '380007',
			name: 'Immortal-JDL',
			parentOperator: '38',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '380008',
			name: 'Immortal-MAXWON',
			parentOperator: '38',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '380009',
			name: 'Immortal-SKC',
			parentOperator: '38',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '410001',
			name: 'Mrslotty-sgp',
			parentOperator: '41',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '420001',
			name: 'Spadeclub-MYR',
			parentOperator: '42',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '420002',
			name: 'Spadeclub-SGD',
			parentOperator: '42',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '420003',
			name: 'Spadeclub-EXCBET',
			parentOperator: '42',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '420004',
			name: 'Spadeclub-Mgwin88',
			parentOperator: '42',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '420005',
			name: 'Spadeclub-LKBET77',
			parentOperator: '42',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '440001',
			name: 'Big Data Centre SDN-5dog',
			parentOperator: '44',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '440002',
			name: 'Big Data Centre SDN-BDC-DOG',
			parentOperator: '44',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '460001',
			name: 'Egadmin-TrillionBet',
			parentOperator: '46',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '460002',
			name: 'Egadmin-supermax996',
			parentOperator: '46',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '480001',
			name: 'Markor-VegasKingsCasino',
			parentOperator: '48',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '480002',
			name: 'Markor-GraceMedia',
			parentOperator: '48',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '480003',
			name: 'Markor-FSBtech-UK',
			parentOperator: '48',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '480004',
			name: 'Markor-FSBtech-Curacao',
			parentOperator: '48',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '480005',
			name: 'Markor-FSBtech-Parimatch',
			parentOperator: '48',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '480006',
			name: 'Markor-BetVictor',
			parentOperator: '48',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '480007',
			name: 'Markor-FSBtech-Africa',
			parentOperator: '48',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '480008',
			name: 'Markor-BetProduction',
			parentOperator: '48',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '480009',
			name: 'Markor-BeSofted',
			parentOperator: '48',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '480010',
			name: 'Markor-Jackpot Molly',
			parentOperator: '48',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '490001',
			name: 'HWFNKWF-Megawin',
			parentOperator: '49',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '490002',
			name: 'HWFNKWF-Sagabe88',
			parentOperator: '49',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '490003',
			name: 'HWFNKWF-Sagabet98',
			parentOperator: '49',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '500001',
			name: 'X2-slotgame666',
			parentOperator: '50',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '500002',
			name: 'X2-x2terminal',
			parentOperator: '50',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '510001',
			name: 'Ironman-betbkk',
			parentOperator: '51',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '510002',
			name: 'Ironman-NineBet',
			parentOperator: '51',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '510003',
			name: 'Ironman-Easyslot',
			parentOperator: '51',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '510004',
			name: 'Ironman-Busbet',
			parentOperator: '51',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '510005',
			name: 'Ironman-Bar4bet',
			parentOperator: '51',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '510006',
			name: 'Ironman-Grandsroyal',
			parentOperator: '51',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '510007',
			name: 'Ironman-Bizzbet',
			parentOperator: '51',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '510008',
			name: 'Ironman-Airlinebet',
			parentOperator: '51',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '510009',
			name: 'Ironman-Jokebet',
			parentOperator: '51',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '510010',
			name: 'Ironman-Turnslot',
			parentOperator: '51',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '510011',
			name: 'Ironman-SUN787',
			parentOperator: '51',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '520001',
			name: 'Winbet-fish',
			parentOperator: '52',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: false,
		},
		{
			fpId: '560001',
			name: 'Neftsoft-MYR',
			parentOperator: '56',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '560002',
			name: 'Neftsoft-THB',
			parentOperator: '56',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '560003',
			name: 'Neftsoft-IDR',
			parentOperator: '56',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '560004',
			name: 'Neftsoft-VND',
			parentOperator: '56',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '560005',
			name: 'Neftsoft-Vegasmyr',
			parentOperator: '56',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '570001',
			name: 'Hwin168-rapa-gresort',
			parentOperator: '57',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '570002',
			name: 'GARYTESTSUBLINE01',
			parentOperator: '57',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '570003',
			name: 'GARYTESTSUBLINE02',
			parentOperator: '57',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '580001',
			name: 'HWUP8FK-GMudah',
			parentOperator: '58',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '580002',
			name: 'HWUP8FK-GMudah2',
			parentOperator: '58',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '580003',
			name: 'HWUP8FK-Gresort',
			parentOperator: '58',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '580004',
			name: 'HWTGBTFNK-gbet',
			parentOperator: '58',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '640001',
			name: 'HWTGBTFNK-eastocean',
			parentOperator: '64',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '640002',
			name: 'HWTGBTFNK-fast2win',
			parentOperator: '64',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
		{
			fpId: '640003',
			name: 'HWTGBTFNK-tsabet',
			parentOperator: '64',
			isMasterOperator: false,
			isReseller: false,
			isTransfer: true,
		},
	],
	returnCode: '0',
	message: '',
};
export default getOperatorListMock;
